export default __webpack_public_path__ + "static/media/menu-users.2cdb8636.svg";